export default __webpack_public_path__ + "static/media/snowflake.ad915532.png";